module.exports = __webpack_public_path__ + "img/9791155350638.f18da86f.jpg";